export function getMaptFilterLiterals(t: any, data?: any) {
  return {
    title: t("getMaptFilterLiterals.title"),
    title2: t("getMaptFilterLiterals.title2"),
    buttoncard: [
      {
        id: t("getMaptFilterLiterals.buttoncard.0.id"),
        icon: t("getMaptFilterLiterals.buttoncard.0.icon"),
        text: t("getMaptFilterLiterals.buttoncard.0.text"),
        selected: data ? data?.buttoncard[0]?.selected : false,
      },
      {
        id: t("getMaptFilterLiterals.buttoncard.1.id"),
        icon: t("getMaptFilterLiterals.buttoncard.1.icon"),
        text: t("getMaptFilterLiterals.buttoncard.1.text"),
        selected: data ? data?.buttoncard[1]?.selected : false,
      },
    ],
    buttondesc: t("getMaptFilterLiterals.buttondesc"),
    title3: t("getMaptFilterLiterals.title3"),
    subtitle3: t("getMaptFilterLiterals.subtitle3"),
    transportcard: [
      {
        backId: t("getMaptFilterLiterals.transportcard.0.backId"),
        id: t("getMaptFilterLiterals.transportcard.0.id"),
        icon: t("getMaptFilterLiterals.transportcard.0.icon"),
        text: t("getMaptFilterLiterals.transportcard.0.text"),
        selected: data ? data?.transportcard[0]?.selected : true,
        mode: "tab1"
      },
      {
        backId: t("getMaptFilterLiterals.transportcard.1.backId"),
        id: t("getMaptFilterLiterals.transportcard.1.id"),
        icon: t("getMaptFilterLiterals.transportcard.1.icon"),
        text: t("getMaptFilterLiterals.transportcard.1.text"),
        selected: data ? data?.transportcard[1]?.selected : true,
        mode: "tab2"
      },
      {
        backId: t("getMaptFilterLiterals.transportcard.2.backId"),
        id: t("getMaptFilterLiterals.transportcard.2.id"),
        icon: t("getMaptFilterLiterals.transportcard.2.icon"),
        text: t("getMaptFilterLiterals.transportcard.2.text"),
        selected: data ? data?.transportcard[2]?.selected : true,
        mode: "tab2"
      },
      {
        backId: t("getMaptFilterLiterals.transportcard.3.backId"),
        id: t("getMaptFilterLiterals.transportcard.3.id"),
        icon: t("getMaptFilterLiterals.transportcard.3.icon"),
        text: t("getMaptFilterLiterals.transportcard.3.text"),
        selected: data ? data?.transportcard[3]?.selected : true,
        mode: "tab2"
      }
      ,
      {
        backId: t("getMaptFilterLiterals.transportcard.4.backId"),
        id: t("getMaptFilterLiterals.transportcard.4.id"),
        icon: t("getMaptFilterLiterals.transportcard.4.icon"),
        text: t("getMaptFilterLiterals.transportcard.4.text"),
        selected: data ? data?.transportcard[4]?.selected : true,
        mode: "tab2"
      }
      ,
      {
        backId: t("getMaptFilterLiterals.transportcard.5.backId"),
        id: t("getMaptFilterLiterals.transportcard.5.id"),
        icon: t("getMaptFilterLiterals.transportcard.5.icon"),
        text: t("getMaptFilterLiterals.transportcard.5.text"),
        selected: data ? data?.transportcard[5]?.selected : true,
        mode: "tab2"
      },
      {
        backId: t("getMaptFilterLiterals.transportcard.6.backId"),
        id: t("getMaptFilterLiterals.transportcard.6.id"),
        icon: t("getMaptFilterLiterals.transportcard.6.icon"),
        text: t("getMaptFilterLiterals.transportcard.6.text"),
        selected: data ? data?.transportcard[6]?.selected : true,
        mode: "tab2"
      },
          {
        backId: t("getMaptFilterLiterals.transportcard.7.backId"),
        id: t("getMaptFilterLiterals.transportcard.7.id"),
        icon: t("getMaptFilterLiterals.transportcard.7.icon"),
        text: t("getMaptFilterLiterals.transportcard.7.text"),
        selected: data ? data?.transportcard[7]?.selected : true,
        mode: "tab2"
      }
    ],
    transportSummary: t("getMaptFilterLiterals.transportSummary"),
    errormsj: t("getMaptFilterLiterals.errormsj"),
    button: t("getMaptFilterLiterals.button"),
  };
}